// extracted by mini-css-extract-plugin
export default {"main":"main__C3StP"};